import * as React from "react";
const SvgPerson = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3.75a3.34 3.34 0 0 0-3.34 3.34v.82a3.341 3.341 0 0 0 6.681 0v-.82a3.34 3.34 0 0 0-3.34-3.34M7.16 7.09a4.841 4.841 0 0 1 9.681 0v.82a4.841 4.841 0 0 1-9.682 0zm-1.138 8.32c1.582-.432 3.77-.887 5.978-.887 2.21 0 4.397.455 5.979.887m-11.957 0a4.015 4.015 0 0 0-2.954 3.878v2.462h17.864v-2.462a4.015 4.015 0 0 0-2.953-3.878M12 16.023c-2.022 0-4.066.42-5.584.834a2.515 2.515 0 0 0-1.848 2.431v.962h14.864v-.962a2.515 2.515 0 0 0-1.848-2.43c-1.517-.415-3.561-.835-5.584-.835",
    clipRule: "evenodd"
  }
));
export default SvgPerson;
